import React from 'react';

import {User, Toast} from 'Services';
import Me from 'Services/Api/Me/Me';

/**
 * Lets staff in more than one service (and admins/service managers) narrow what they see to one service.
 *
 * @function ServiceSwitcher
 * @param {string} className
 * @return {JSX.Element|null}
 * @constructor
 */
const ServiceSwitcher = ({className = ''}) => {
    const access = User.data?.service_access;

    if (!access?.enabled) {
        return null;
    }

    const options = access.services.filter(service => access.switchable_service_ids.includes(service.id));

    if (options.length < 2) {
        return null;
    }

    const handleChange = async (event) => {
        const request = await Me.updateService({
            service_id: event.target.value || null,
        });

        if (!request.success) {
            return Toast.error();
        }

        // Reload so every list on the page is fetched again for the new service.
        window.location.reload();
    };

    return (
        <label className={`flex items-center text-sm text-white font-roboto ${className}`}>
            <span className="mr-2">Service</span>
            <select
                className="rounded-full border-0 py-1 pl-3 pr-8 text-sm text-app-typography"
                value={access.active_service_id ?? ''}
                onChange={handleChange}
            >
                <option value="">{access.sees_all_services ? 'All services' : 'All my services'}</option>
                {options.map(service => (
                    <option key={service.id} value={service.id}>{service.name}</option>
                ))}
            </select>
        </label>
    );
};

export default ServiceSwitcher;
